import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    public isLoading = false;
    message = '';

    setLoading(isLoading = true, message = '') {
        this.isLoading = isLoading;
        this.message = message;
    }
}
